import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { contactItems, kakaoInquiryUrl } from "../../data/specialTour";
import { ContentBand, Inner, PageIntro, QuickContactBar, SectionHeader, SpecialTourLayout } from "./SpecialTourLayout";

const inquiryChecklist = [
  "희망 지역",
  "출발 예정 날짜와 여행 기간",
  "인원과 동행 형태",
  "골프만 또는 골프 + 자유여행",
  "원하는 식사, 온천, 관광 스타일",
];

const iconByLabel: Record<string, JSX.Element> = {
  "카카오톡 문의": <ChatBubbleOutlineIcon />,
  전화: <PhoneOutlinedIcon />,
  이메일: <EmailOutlinedIcon />,
  홈페이지: <LanguageIcon />,
  YouTube: <YouTubeIcon />,
};

export function ContactPage() {
  return (
    <SpecialTourLayout>
      <PageIntro
        eyebrow="Contact"
        title="견적 문의는 카카오톡으로 편하게 남겨주세요"
        body="정해진 양식이 없어도 됩니다. 날짜, 지역, 인원만 알려주시면 골프장과 이동 동선을 확인해 맞춤 일정으로 안내합니다."
        image="/special-tour-assets/special-tour-logo.jpg"
      />
      <ContentBand className="bg-white">
        <Inner>
          <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr]">
            <div>
              <SectionHeader
                title="문의할 때 알려주시면 좋은 것"
                body="처음에는 대략적인 정보만 있어도 충분합니다. 세부 조건은 상담하면서 맞춰가면 됩니다."
              />
              <ul className="grid gap-3">
                {inquiryChecklist.map((item, index) => (
                  <li key={item} className="grid grid-cols-[40px_1fr] gap-3 rounded-lg bg-[#f7f5ef] p-4">
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#e8f2e6] text-sm font-900 text-[#1e6b34]">
                      {index + 1}
                    </span>
                    <span className="self-center text-sm font-800 text-[#344138]">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="rounded-lg border border-[#dce3d8] bg-[#fbfaf6] p-6 shadow-sm md:p-8">
              <h2 className="text-3xl font-900 text-[#15391f]">스페셜투어 상담 채널</h2>
              <p className="mt-4 text-base leading-8 text-[#596559]">
                카카오톡 채널을 기본 문의 창구로 사용합니다. 전화와 이메일도 함께 열어두었습니다.
              </p>
              <div className="mt-6 grid gap-3">
                {contactItems.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    className="grid grid-cols-[44px_1fr] gap-4 rounded-lg border border-[#dce3d8] bg-white p-4 transition hover:border-[#9fb99a]"
                  >
                    <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#e8f2e6] text-[#1e6b34]">
                      {iconByLabel[item.label]}
                    </span>
                    <span>
                      <span className="block text-sm font-900 text-[#15391f]">{item.label}</span>
                      <span className="mt-1 block text-sm text-[#596559]">{item.value}</span>
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </Inner>
      </ContentBand>
      <ContentBand className="bg-[#e8f2e6]">
        <Inner>
          <div className="rounded-lg bg-white p-6 shadow-sm md:p-8">
            <div className="grid gap-6 md:grid-cols-[1fr_auto] md:items-center">
              <div>
                <h2 className="text-3xl font-900 text-[#15391f]">바로 상담을 시작할 수 있습니다</h2>
                <p className="mt-4 max-w-2xl text-base leading-8 text-[#596559]">
                  카카오톡으로 연결되며, 여행 일정과 견적 상담은 채팅에서 이어집니다.
                </p>
              </div>
              <a
                href={kakaoInquiryUrl}
                className="inline-flex min-h-12 items-center justify-center gap-2 rounded-lg bg-[#FEE500] px-5 text-sm font-900 text-[#1b1600] transition hover:bg-[#f3db00]"
              >
                <ChatBubbleOutlineIcon sx={{ fontSize: 20 }} />
                카카오톡 문의 열기
              </a>
            </div>
            <div className="mt-7">
              <QuickContactBar />
            </div>
          </div>
        </Inner>
      </ContentBand>
    </SpecialTourLayout>
  );
}
